module.exports = __webpack_public_path__ + "static/media/search_header_back.fb77f215.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/search_header_back.png
// module id = 1856
// module chunks = 0 1